"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCategory = void 0;
var EventCategory;
(function (EventCategory) {
    EventCategory["Campaign"] = "campaign";
    EventCategory["Message"] = "message";
    EventCategory["NetworkConnect"] = "network_connect";
    EventCategory["InfluencerRelations"] = "influencer_relations";
    EventCategory["InfluencerAccount"] = "influencer_account";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
//# sourceMappingURL=eventCategory.enum.js.map